import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Redirect } from 'react-router';

import { DossierRoute } from '../../pages/Dossier/Route';
import { FiltersPanel } from '../../pages/Filters';
import { HomepageRoute } from '../../pages/Homepage/HomepageRoute';
import { MessageTemplateRoute } from '../../pages/MessageTemplate/Route';
import { PipelineRoute } from '../../pages/Pipeline/Route';
import { TodoRoute } from '../../pages/Todo/Route';

import { AB_CalendlyCallback } from '../../pages/CalendlyCallback/AB_CalendlyCallback';
import { AB_CalendlyEvents } from '../../pages/CalendlyEvents/AB_CalendlyEvents';
import { useIsCalendlyEnabled } from '../../resources/calendly/AB_calendly-hooks';

import { BrowserHistoryReplace } from './BrowserHistoryReplace';

export const DEFAULT_VIEW_ROUTE = '/homepage';

export const Routes = (): JSX.Element => {
    // BEGIN - AB ab_calendly - PR #TODO_AFTER_PR_CREATION_ab_calendly
    const isCalendlyEnabled = useIsCalendlyEnabled();
    // END - AB ab_calendly - PR #TODO_AFTER_PR_CREATION_ab_calendly

    return (
        <React.Fragment>
            <React.Fragment>
                <Route path="/todo" component={FiltersPanel} />
                <Route path="/process" component={FiltersPanel} />
                <Route path="/homepage" component={FiltersPanel} />
            </React.Fragment>
            <BrowserHistoryReplace from="/" to={DEFAULT_VIEW_ROUTE} />
            <Switch>
                {/* BEGIN - AB ab_calendly - PR #TODO_AFTER_PR_CREATION_ab_calendly */}
                {isCalendlyEnabled && (
                    <Route path="/auth/calendly/callback" component={AB_CalendlyCallback} />
                )}
                {isCalendlyEnabled && (
                    <Route path="/calendly/events" component={AB_CalendlyEvents} />
                )}
                {/* END - AB ab_calendly - PR #TODO_AFTER_PR_CREATION_ab_calendly */}
                {HomepageRoute}
                {PipelineRoute}
                {TodoRoute}
                {MessageTemplateRoute}
                <DossierRoute />
                <Redirect to={DEFAULT_VIEW_ROUTE} />
            </Switch>
        </React.Fragment>
    );
};
